export default __webpack_public_path__ + "static/media/megaphone-fill.9aeaf63d.svg";